import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Breadcrumbs, { breadcrumbsClasses } from '@mui/material/Breadcrumbs';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';
import { useLocation } from 'react-router';

const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
  margin: theme.spacing(1, 0),
  [`& .${breadcrumbsClasses.separator}`]: {
    color: (theme.vars || theme).palette.action.disabled,
    margin: 1,
  },
  [`& .${breadcrumbsClasses.ol}`]: {
    alignItems: 'center',
  },
}));

export default function NavbarBreadcrumbs() {
  const location = useLocation();
  const currentPath: string = location.pathname;

  // Split the path and filter out empty segments
  const pathSegments = currentPath.split('/').filter(Boolean);

  // Optionally, map segment names to display names
  const displayNames: Record<string, string> = {
    dashboard: 'Dashboard',
    home: 'Home',
    // Add more mappings as needed
  };

  // Build breadcrumb items
  const breadcrumbs = pathSegments.map((segment, idx) => {
    const isLast = idx === pathSegments.length - 1;
    const displayName =
      displayNames[segment] ||
      segment.charAt(0).toUpperCase() + segment.slice(1);

    return (
      <Typography
        key={segment}
        variant="body1"
        sx={{
          color: isLast ? 'text.primary' : 'inherit',
          fontWeight: isLast ? 600 : 400,
        }}>
        {displayName}
      </Typography>
    );
  });

  // Optionally, add a root breadcrumb (e.g., Dashboard)
  const rootBreadcrumb = (
    <Typography key="dashboard" variant="body1">
      Dashboard
    </Typography>
  );

  return (
    <StyledBreadcrumbs
      aria-label="breadcrumb"
      separator={<NavigateNextRoundedIcon fontSize="small" />}>
      {/* {rootBreadcrumb} */}
      {breadcrumbs}
    </StyledBreadcrumbs>
  );
}
